<template>
  <div>
    <v-container class="pt-0">
      <span class="headline">{{$t('friends.title')}}</span>
      <v-row v-if="friendshipRequests.length > 0">
        <v-col>
        <alert :text="$tc('friendshipRequest.incoming', $store.state.friendshipRequests.length, {n: $store.state.friendshipRequests.length})" :type="'info'" :link="'/friendshipRequests'"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn to="/friends/search" class="primary">
            <v-icon left>mdi-magnify</v-icon>{{$t('friends.find-friends')}}
          </v-btn>
        </v-col>
      </v-row>
      <div v-if="friends && friends.length > 0">
        <v-row v-for="friend in friends" v-bind:key="friend.uid" class="align-center">
          <v-col>
            <user-widget :user="friend" :actions="{}" :actionsDisabled="$store.state.isLoading" />
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
import { ACTION_LOAD_FRIENDS } from "@/plugins/store.js";
// import HelpIcon from "@/widgets/HelpIcon";
import { EVENT_REFRESH_DATA } from "@/plugins/eventbus";
import Alert from "@/widgets/Alert";

export default {
  name: "Friends",

  components: {
    Alert
  },

  data: () => ({
    loading: false,
  }),

  computed: {
    friends: function() {
      return this.$store.state.friends;
    },
    friendshipRequests: function() {
      return this.$store.state.friendshipRequests;
    }
  },

  mounted() {
    this.resolveFriends();
    this.$eventBus.$on(EVENT_REFRESH_DATA, this.onRefreshData);
  },
  beforeDestroy() {
    this.$eventBus.$off(EVENT_REFRESH_DATA, this.onRefreshData);
  },

  methods: {
    onRefreshData() {
      this.resolveFriends();
    },
    resolveFriends() {
      this.loading = true;
      this.$store.dispatch(ACTION_LOAD_FRIENDS).then(() => {
        this.loading = false;
      }).catch(error => {
        this.loading = false;
        this.$common.onError(error)
      });
    },
  }
};
</script>
